import React from 'react'
import { DATE_FORMAT, FULL_DATE_FORMAT, createIsoTimeRange, tzDate, DEFAULT_TIMEZONE } from 'app/lib/utils/DateUtils';

export default EventItem = (props) => {
    let pe = props.event;
    return <div className="event-item flex-col">
        <div className="item event">
            <div className="label">Event:</div> <div className="value">{pe.event}</div>
        </div>
        <div className="item date">
            <div className="label">Date:</div> <div className="value">{pe.date}</div>
        </div>
        <div className="item ip">
            <div className="label">IP:</div> <div className="value">{pe.ip}</div>
        </div>
        <div className="item location">
            <div className="label">Location:</div> <div className="value">{pe.location}</div>
        </div>
        <div className="item user-agent">
            {/* User Agent: {pe.user_agent} */}
        </div>
        <div className="item utm-source">
            <div className="label">UTM Source:</div> <div className="value">{pe.utm_source}</div>
        </div>
        <div className="item utm-medium">
            <div className="label">UTM Medium:</div> <div className="value">{pe.utm_medium}</div>
        </div>
        <div className="item utm-campaign">
            <div className="label">UTM Campaign:</div> <div className="value">{pe.utm_campaign}</div>
        </div>
        <div className="item utm-term">
            <div className="label">UTM Term:</div> <div className="value">{pe.utm_term}</div>
        </div>
        <div className="item utm-content">
            <div className="label">UTM Content:</div> <div className="value">{pe.utm_content}</div>
        </div>
        <div className="item client-fingerprint">
            <div className="label">Client Fingerprint:</div> <div className="value">{pe.client_fingerprint}</div>
        </div>
        <div className="item server-fingerprint">
            <div className="label">Server Fingerprint:</div> <div className="value">{pe.server_fingerprint}</div>
        </div>
        <div className="item session">
            <div className="label">Session:</div> <div className="value">{pe.parent_session}</div>
        </div>
        <div className="item parent-session">
            <div className="label">Parent Session:</div> <div className="value">{pe.parent_session}</div>
        </div>
        <div className="item tracking_id">
            <div className="label">Tracking ID:</div> <div className="value">{pe.tracking_id}</div>
        </div>
    </div>
}